// Grove icons are lucide icon names; web and native map them to their own lucide
// package. Groves made before icons only have an emoji, mapped here.

export const GROVE_ICONS = [
  'trees',
  'sprout',
  'leaf',
  'flower-2',
  'mountain',
  'sun',
  'flame',
  'zap',
  'footprints',
  'dumbbell',
  'bike',
  'book-open',
  'brain',
  'heart',
  'users',
  'trophy',
] as const

export type GroveIcon = (typeof GROVE_ICONS)[number]

export const DEFAULT_GROVE_ICON: GroveIcon = 'trees'

const FROM_EMOJI: Record<string, GroveIcon> = {
  '🌳': 'trees',
  '🌲': 'trees',
  '🌱': 'sprout',
  '🌵': 'sprout',
  '🌿': 'leaf',
  '🍀': 'leaf',
  '🌻': 'flower-2',
  '🌸': 'flower-2',
  '🔥': 'flame',
  '⚡️': 'zap',
  '⚡': 'zap',
  '🏃': 'footprints',
  '📚': 'book-open',
}

export function isGroveIcon(name: string): name is GroveIcon {
  return (GROVE_ICONS as readonly string[]).includes(name)
}

export function groveIcon(g: { icon?: string; emoji?: string }): GroveIcon {
  if (g.icon && isGroveIcon(g.icon)) return g.icon
  return (g.emoji && FROM_EMOJI[g.emoji.trim()]) || DEFAULT_GROVE_ICON
}
